<!-- @format -->

<!--
  The grid settings and the grid-column values below are intentionally identical to app-plan-header,
  so that the module totals line up with the plan selector and its info list above them:
  even items follow the plan selector's column, odd items the info list's column.
-->
<fudis-grid [columns]="12" [width]="'initial'" [columnGap]="'sm'" [rowGap]="'sm'" *transloco="let t">
  @for (moduleTotal of firstLevelModuleTotals$ | async; track moduleTotal.moduleId) {
    <fudis-grid-item
      [columns]="$even ? { xs: 'stretch', md: '1 / 7', xl: '1 / 6', xxl: '1 / 5' } : { xs: 'stretch', lg: '7 / 13', xl: '6 / 12' }">
      @let moduleLabelId = "total-credits-module-" + moduleTotal.moduleId;
      <fudis-body-text [variant]="'lg-regular'" [classList]="'fudis-mb-xxs'" [attr.id]="moduleLabelId">
        {{ moduleTotal.moduleLabel }}
      </fudis-body-text>
      <fudis-dl [variant]="'compact'" [attr.aria-labelledby]="moduleLabelId">
        <fudis-dl-item>
          <fudis-dt [contentText]="t('TIMELINE.TIMED_CREDITS')" />
          <fudis-dd [contentText]="moduleTotal.timedCredits | creditRange: 'TEXT' : true" />
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('TIMELINE.ATTAINED_CREDITS')" />
          <fudis-dd [contentText]="moduleTotal.attainedCredits | decimalNumber" />
        </fudis-dl-item>
      </fudis-dl>
    </fudis-grid-item>
  }
</fudis-grid>
